import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Tooltip from 'flarum/common/components/Tooltip';
import { ELEMENT_COLORS, ELEMENT_ICONS, BONUS_EFFECT_COLORS, BONUS_EFFECT_ICONS, BONUS_COLOR, formatBonusDescription } from '../../common';
import attachCardTilt from '../../common/helpers/attachCardTilt';
export default class CardComponent extends Component {
  constructor() {
    super(...arguments);
    // 3D pointer-tilt, full cards only (mini slider thumbnails are too small for it
    // to read). See common/helpers/attachCardTilt.ts for the implementation.
    _defineProperty(this, "detachTiltFn", null);
    _defineProperty(this, "attachTilt", vnode => {
      this.detachTiltFn = attachCardTilt(vnode.dom);
    });
    _defineProperty(this, "detachTilt", () => {
      var _this$detachTiltFn;
      (_this$detachTiltFn = this.detachTiltFn) == null || _this$detachTiltFn.call(this);
      this.detachTiltFn = null;
    });
  }
  view() {
    const _this$attrs = this.attrs,
      card = _this$attrs.card,
      selected = _this$attrs.selected,
      disabled = _this$attrs.disabled,
      compact = _this$attrs.compact,
      cardBackImage = _this$attrs.cardBackImage,
      onclick = _this$attrs.onclick;
    return card.isBonus() ? this.viewBonus(card, selected, disabled, compact, cardBackImage, onclick) : this.viewElemental(card, selected, disabled, compact, cardBackImage, onclick);
  }
  viewElemental(card, selected, disabled, compact, cardBackImage, onclick) {
    const element = card.element();
    const color = ELEMENT_COLORS[element] || '#888';
    const icon = ELEMENT_ICONS[element] || 'fas fa-question';
    const label = app.translator.trans("forumaker-arena.lib.elements.".concat(element)) || element;
    return m("div", Object.assign({
      className: ['ArenaCard', 'ArenaCard--elemental', selected ? 'ArenaCard--selected' : '', disabled ? 'ArenaCard--disabled' : '', compact ? 'ArenaCard--compact' : 'ArenaCard--full'].filter(Boolean).join(' '),
      onclick: !disabled && onclick ? () => onclick(card) : undefined,
      style: {
        '--element-color': color
      }
    }, !compact ? {
      oncreate: this.attachTilt,
      onremove: this.detachTilt
    } : {}), m("div", {
      className: "ArenaCard-header".concat(cardBackImage ? ' ArenaCard-header--skinned' : ''),
      style: cardBackImage ? {
        backgroundImage: "url(".concat(cardBackImage, ")")
      } : {
        backgroundColor: color
      }
    }, m("div", {
      className: "ArenaCard-avatar"
    }, card.imageUrl() ? m("img", {
      src: card.imageUrl(),
      alt: card.name()
    }) : m("i", {
      className: icon
    }))), m("div", {
      className: "ArenaCard-body"
    }, m("div", {
      className: "ArenaCard-name"
    }, card.name()), !compact && card.description() && m("div", {
      className: "ArenaCard-description"
    }, card.description()), m("div", {
      className: "ArenaCard-footer"
    }, !compact && m("div", {
      className: "ArenaCard-bonusTag"
    }, m("i", {
      className: icon,
      style: {
        color
      }
    }), " ", label), m("div", {
      className: "ArenaCard-stats ".concat(compact ? 'ArenaCard-stats--compact' : '')
    }, m("span", {
      className: "ArenaCard-stat ArenaCard-stat--attack",
      title: app.translator.trans('forumaker-arena.admin.card_edit.attack_label')
    }, m("i", {
      className: "fas fa-axe-battle"
    }), " ", m("span", null, card.attack())), m("span", {
      className: "ArenaCard-stat ArenaCard-stat--defense",
      title: app.translator.trans('forumaker-arena.admin.card_edit.defense_label')
    }, m("i", {
      className: "fas fa-shield-alt"
    }), " ", m("span", null, card.defense())), m("span", {
      className: "ArenaCard-stat ArenaCard-stat--cost",
      title: app.translator.trans('forumaker-arena.lib.stats.mana')
    }, m("i", {
      className: "fas fa-gem"
    }), " ", m("span", null, card.cost()))))));
  }
  viewBonus(card, selected, disabled, compact, cardBackImage, onclick) {
    var _card$bonusEffect, _card$bonusValue;
    const effect = (_card$bonusEffect = card.bonusEffect()) != null ? _card$bonusEffect : '';
    const color = BONUS_EFFECT_COLORS[effect] || BONUS_COLOR;
    const icon = BONUS_EFFECT_ICONS[effect] || 'fas fa-star';
    const label = effect ? app.translator.trans("forumaker-arena.lib.bonus_effects.".concat(effect)) : app.translator.trans('forumaker-arena.admin.card_edit.type_bonus');
    // formatBonusDescription (plain string), NOT app.translator.trans():
    // trans() with a numeric ICU param returns an ARRAY of Mithril children,
    // and .ArenaCard-description is a -webkit-box with -webkit-line-clamp —
    // WebKit's clamp misplaces its ellipsis when the box has several inline
    // children, drawing "…" mid-element even though the text fits the three
    // lines. Same pitfall CardEditModal's preview already documents.
    const desc = card.description() || (effect ? formatBonusDescription(effect, (_card$bonusValue = card.bonusValue()) != null ? _card$bonusValue : null) : '');
    const cardEl = m("div", Object.assign({
      className: ['ArenaCard', 'ArenaCard--bonus', selected ? 'ArenaCard--selected' : '', disabled ? 'ArenaCard--disabled' : '', compact ? 'ArenaCard--compact' : 'ArenaCard--full'].filter(Boolean).join(' '),
      onclick: !disabled && onclick ? () => onclick(card) : undefined,
      style: {
        '--element-color': color
      }
    }, !compact ? {
      oncreate: this.attachTilt,
      onremove: this.detachTilt
    } : {}), m("div", {
      className: "ArenaCard-header ArenaCard-header--bonus".concat(cardBackImage ? ' ArenaCard-header--skinned' : ''),
      style: cardBackImage ? {
        backgroundImage: "url(".concat(cardBackImage, ")")
      } : {
        backgroundColor: color
      }
    }, m("div", {
      className: "ArenaCard-avatar"
    }, card.imageUrl() ? m("img", {
      src: card.imageUrl(),
      alt: card.name()
    }) : m("i", {
      className: icon
    }))), m("div", {
      className: "ArenaCard-body ArenaCard-body--bonus"
    }, m("div", {
      className: "ArenaCard-name"
    }, card.name()), !compact && desc && m("div", {
      className: "ArenaCard-description ArenaCard-description--bonus"
    }, desc), m("div", {
      className: "ArenaCard-footer"
    }, !compact && m("div", {
      className: "ArenaCard-bonusTag"
    }, m("i", {
      className: icon,
      style: {
        color
      }
    }), " ", label), m("div", {
      className: "ArenaCard-stats ".concat(compact ? 'ArenaCard-stats--compact' : '')
    }, m("span", {
      className: "ArenaCard-stat ArenaCard-stat--cost",
      title: app.translator.trans('forumaker-arena.lib.stats.mana')
    }, m("i", {
      className: "fas fa-gem"
    }), " ", m("span", null, card.cost()))))));

    // Compact cards (slider thumbnails) hide the description text to stay
    // small, so surface it as a hover tooltip instead.
    return compact && desc ? m(Tooltip, {
      text: desc
    }, cardEl) : cardEl;
  }
}
flarum.reg.add('forumaker-arena', 'forum/components/CardComponent', CardComponent);